import * as React from 'react';
import { api, handleApiError } from 'services/api';
import type { ViagemControle } from 'pages/viagens-controle/types';

export type RejectViagemControlePayload = {
  id: number;
  justificationId: number;
  comment: string;
};

export const useRejectViagemControle = () => {
  const rejectViagemControle = React.useCallback(async ({
    id,
    justificationId,
    comment,
  }: RejectViagemControlePayload) => {
    try {
      const { data } = await api.post<ViagemControle>(
        `/viagens-controle/${id}/reject`,
        { justificationId, comment }
      );
      return data;
    } catch (e) {
      throw handleApiError(e);
    }
  }, []);

  return {
    rejectViagemControle,
  };
};
